module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Cuenca","short_name":"Cuenca","description":"La única cuenta que necesitas en México","start_url":"/","background_color":"#FEFAF3","theme_color":"#3D4975","display":"standalone","icon":"src/images/logos/cuenca-favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3cbdb6a68fe7847073dfcb3c76b73b85"},
    },{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"facebookPixel":{"pixelId":"436171176938956","cookieName":"cuenca-facebook-pixel"},"googleAnalytics":{"trackingId":"G-8K939XKHFJ","cookieName":"cuenca-google-analytics"},"tikTokPixel":{"pixelId":"C575G2KK7EFNSJPVU970","cookieName":"cuenca-tiktok-pixel"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
